export default __webpack_public_path__ + "static/carousel-hero-classic-1582a25388998f695d38e7b6e374a284.png";